import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {StockInTransitReportData} from "./stock-in-transit-report.data";

@Injectable()
export class StockInTransitReportModel extends ReportModel<StockInTransitReportData> {
    constructor(injector: Injector) {
        super(injector, StockInTransitReportData);
    }
}
